import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import { useEffect } from 'react';


import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Util from '../../lib/Util';

export default () => {

    useEffect(()=>{
        document.title = Config.SERVICE_TITLE + ' Dashboard';
    });

    const post_test = () => {

/*      
      let form  =new URLSearchParams;
      form.append('email','dev06.choi@gmail.com');
      form.append('password','00000000');
      Util.post('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login',form,(ret)=>{},(err)=>{});
      */

      const t = new Date().getTime();
      Util.get('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile?t='+t,null,(ret)=>{},(err)=>{});

      /*
      axios.post('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login', {
        key1: 'value1',
        key2: 'value2',
    })
    .then(response => {
        console.log('Success:', response.data);
    })
    .catch(error => {
        console.error('Error:', error);
    });
     */

    
/*
    let form  =new FormData;
    form.append('email','dev06.choi@gmail.com');
    form.append('password','00000000');

    const formData = new URLSearchParams();
    formData.append('email','dev06.choi@gmail.com');
    formData.append('password','00000000');

    axios.post('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login',formData,
      {
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true // Config.FLAG_REQUEST_SSL
      })
      .then(function (response) { 
        console.log('67',response);
      })
      .catch(function(err){});
*/

/*
axios.get('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile',{

  withCredentials: true // Config.FLAG_REQUEST_SSL
} )
  .then(function (response) { 
    console.log('67',response);
  })
  .catch(function(err){  alert('error'); });
*/

/*
fetch('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile', {
  method: "GET",
   credentials: 'include', // 'include', 'same-origin', or 'omit'
})
  .then((response) => { console.log('response LOGIN: ',response); })
*/

/*
const formData = new URLSearchParams();
formData.append('email','dev06.choi@gmail.com');
formData.append('password','00000000');

      
      fetch('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login', {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((response) => { console.log('response LOGIN: ',response); })

        







        fetch('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile', {
          method: "GET",
           credentials: 'include', // 'include', 'same-origin', or 'omit'
        })
          .then((response) => { console.log('response LOGIN: ',response); })
*/
    };

    const breadcrumbs = [
      <Link underline="hover" key="1" color="inherit" href="/" >
        MUI
      </Link>,
      <Link
        underline="hover"
        key="2"
        color="inherit"
        href="/material-ui/getting-started/installation/"
       
      >
        Core
      </Link>,
      <Typography key="3" color="text.primary">
        Breadcrumb
      </Typography>,
    ];


    const nav_menu = [<Link>teim1</Link>,<Link>item2</Link>,<Link>item3</Link>];
    return (
        <>
            <Header code={'template'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px',textAlign:'center', backgroundColor:'#00ff00',margin:'0px auto'}}>
                
           
                Dashboard<br /> 

                <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>




                <TextField
          label="With normal TextField"
          id="standard-start-adornment"
          sx={{ m: 1, width: '25ch' }}
          InputProps={{
            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
          }}
          variant="standard"
        />
        <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{color:'#222222',backgroundColor:'#ff0000'}}
      >
       {nav_menu}
      </Breadcrumbs>
        <FormControl variant="standard" sx={{ m: 1, mt: 3, width: '25ch' }}>
          <Input
            id="standard-adornment-weight"
            endAdornment={<InputAdornment position="end">kg</InputAdornment>}
            aria-describedby="standard-weight-helper-text"
            inputProps={{
              'aria-label': 'weight',
            }}
          />
          <FormHelperText id="standard-weight-helper-text">Weight</FormHelperText>
        </FormControl>
        <FormControl sx={{ m: 1, width: '25ch' }} >
          
          <Input
            id="standard-adornment-password"
            type={'password'}
            disableUnderline
          
            sx={{
                '& input::placeholder': {
                    minHeight:'48x',
                  fontSize: '13px',
                  paddingTop:'-4px',
                  color:'#ff0000',
                  paddingTop:'-19px !important'
                },
              }}
           
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                 sx={{ fontSize:11 }}
                 
                >
                 <VisibilityOff style={{fontSize:18}} />
                </IconButton>
              </InputAdornment>
            }

            
placeholder='패스워드'

            style={{height:'48px',backgroundColor:'#f8f8f8',borderRadius:'8px',padding:'4px',paddingTop:'8px',paddingLeft:'12px'}}
          />
        </FormControl>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
          <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel>
          <Input
            id="standard-adornment-amount"
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
          />
        </FormControl>

        <TextField
          required
          id="outlined-required"
            style={{fontSize:'13px', minHeight:'36px',borderColor:'#ffffff'}}
            disableUnderline
          placeholder='test'
          defaultValue="Hello World"
        />
        <TextField
          id="standard-multiline-flexible"
          label="Multiline"
          multiline
          disableUnderline
          variant="standard"
        />

<TextField
  placeholder="Password"
  variant="outlined"
  style={{height:'42px',width:'200px'}}
  InputProps={{
    sx: {
        height:'42px',
        fontSize:'13px',
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f8f8f8',  // Set grey background
        '& fieldset': {
          border: 'none',              // Remove border even when focused
        },
        '&:hover fieldset': {
          border: 'none',              // Remove border on hover
        },
        '&.Mui-focused fieldset': {
          border: 'none',              // Remove border when focused
        },
      },
      '::placeholder': {
        fontSize: '12px',              // Set placeholder font size
      },
    },


    endAdornment: (
        <InputAdornment position="end"  sx={{ paddingRight: '8px' }}>
          <IconButton
           
            edge="end"
            sx={{ padding: 0 }} // Optional: adjust icon padding
          >
             <VisibilityOff sx={{fontSize:'18px'}} /> 
          </IconButton>
        </InputAdornment>
      ),


  }}
  sx={{
    '& .MuiInputBase-input::placeholder': {
      fontSize: '12px',                // Ensure placeholder font size
    },
  }}


/>


<TextField
  placeholder="Password"
  variant="outlined"
  style={{height:'42px',width:'200px'}}
  InputProps={{
    sx: {
        height:'42px',
        fontSize:'13px',
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f8f8f8',  // Set grey background
        '& fieldset': {
          border: 'none',              // Remove border even when focused
        },
        '&:hover fieldset': {
          border: 'none',              // Remove border on hover
        },
        '&.Mui-focused fieldset': {
          border: 'none',              // Remove border when focused
        },
      },
      '::placeholder': {
        fontSize: '12px',              // Set placeholder font size
      },
    },


    startAdornment: (
        <InputAdornment position="start"  sx={{ paddingRight: '8px' }}>
          <IconButton
           
            edge="end"
            sx={{ padding: 0 }} // Optional: adjust icon padding
          >
             <VisibilityOff sx={{fontSize:'18px'}} /> 
          </IconButton>
        </InputAdornment>
      ),


  }}
  sx={{
    '& .MuiInputBase-input::placeholder': {
      fontSize: '12px',                // Ensure placeholder font size
    },
  }}


/>
<br />
<Button onClick={()=>{post_test()}}>POST</Button>
            </div>
        </>
    );

}